export const getLocale = function() {
  return document.location.pathname.split('/')[1];
};
